import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ArraySignal } from '@studiohyperdrive/ngx-utils';

import { CypressTagDirective } from '@vlaio/cypress/core';

import { VlaioIconComponent } from '../../icon';
import { VlaioButtonAbstractComponent } from '../shared';

@Component({
	selector: 'vlaio-external-button',
	templateUrl: './external-button.component.html',
	styleUrls: ['./external-button.component.scss', '../shared/button-variants.scss'],
	standalone: true,
	imports: [NgClass, CypressTagDirective, VlaioIconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class VlaioExternalButtonComponent extends VlaioButtonAbstractComponent {
	/**
	 * The link to navigate to.
	 *
	 * If the property {@link isDisabled} is set to `true`,
	 * navigation will be blocked.
	 */
	public link: ArraySignal<string> = input.required();
}
